import { useState } from "react";
import { useTranslation } from "react-i18next";

import RequirementBadge from "@/features/certifications/module/components/RequirementBadge";
import ResourceItem from "@/features/certifications/module/components/ResourceItem";
import { useResourceDownload } from "@/features/certifications/module/hooks/useResourceDownload";
import { buildResourceRows } from "@/features/certifications/module/utils";
import { ReadingsCardProps } from "@/features/certifications/module/components/types";

import "./styles.css";

const ReadingsCard = ({
  moduleId,
  certificationSlug,
  items,
  itemSatisfaction,
}: ReadingsCardProps) => {
  const { t } = useTranslation();
  const [downloadedIds, setDownloadedIds] = useState<number[]>([]);
  const { handleDownload, isBusy, downloadingId } = useResourceDownload({
    moduleId,
    certificationSlug,
    onDownloaded: (id) =>
      setDownloadedIds((previous) =>
        previous.includes(id) ? previous : [...previous, id],
      ),
  });
  const rows = buildResourceRows(t, items);

  return (
    <section className="certification-card module-card flex flex-col gap-300">
      <header className="module-card-header flex items-center justify-between gap-300">
        <h2 className="certification-heading header-s-medium">
          {t("certification.module.readings.heading")}
        </h2>

        <RequirementBadge isRequired />
      </header>

      <ul className="module-card-body module-resource-list flex flex-col">
        {rows.map((row) => (
          <ResourceItem
            key={row.id}
            row={row}
            isDone={
              Boolean(itemSatisfaction[row.id]) ||
              downloadedIds.includes(row.id)
            }
            isDownloading={downloadingId === row.id}
            isBusy={isBusy}
            onDownload={handleDownload}
          />
        ))}
      </ul>
    </section>
  );
};

export default ReadingsCard;
